export const PRODUCTS = [
  {
    line: 'RORO MULTI BALM',
    title: 'BLEU',
    desc1: '페이스&바디용 비건 보습 멀티밤',
    desc2: (
      <span>
        건조한 피부에 쓱쓱!! <br />
        수분가득 촉촉하게 보습케어
      </span>
    ),
    tags: ['프랑스 이브비건', '저자극 테스트 완료', '보습 테스트 완료'],
    name: '로로 블루',
    openImage: require('../../asset/images/product/blue-open.png'),
    closeImage: require('../../asset/images/product/blue-close.png'),
    uri: '/product/BLEU',
    url: 'https://smartstore.naver.com/levrai_cosmetic/products/7078661867',
  },
  {
    line: 'RORO MULTI BALM',
    title: 'VERT',
    name: '로로 베르',
    desc1: '페이스&바디용 비건 진정 멀티밤',
    desc2: (
      <span>
        자극받은 피부에 쓱쓱!! <br />
        부드럽고 편안하게 진정케어
      </span>
    ),
    tags: ['프랑스 이브비건', '저자극 테스트 완료', '진정 테스트 완료'],
    openImage: require('../../asset/images/product/green-open.png'),
    closeImage: require('../../asset/images/product/green-close.png'),
    uri: '/product/VERT',
    url: 'https://smartstore.naver.com/levrai_cosmetic/products/7087782778',
  },
  {
    line: 'COCO MULTI BALM',
    title: 'ROUGE',
    name: '코코 루즈',
    desc1: '립&치크용 비건 컬러 멀티밤',
    desc2: (
      <span>
        건조한 입술과 볼에 쓱쓱!! <br />
        촉촉하고 은은하게 생기케어
      </span>
    ),
    tags: ['프랑스 이브비건', '저자극 테스트 완료', '선명한 발색'],
    openImage: require('../../asset/images/product/red-open.png'),
    closeImage: require('../../asset/images/product/red-close.png'),
    uri: '/product/ROUGE',
    url: 'https://smartstore.naver.com/levrai_cosmetic/products/7087821388',
  },
  {
    line: 'COCO MULTI BALM',
    title: 'ROSE',
    name: '코코 로즈',
    desc1: '립&치크용 비건 컬러 멀티밤',
    desc2: (
      <span>
        건조한 입술과 볼에 쏙쏙!! <br />
        촉촉하고 은은하게 생기케어
      </span>
    ),
    tags: ['프랑스 이브비건', '저자극 테스트 완료', '선명한 발색'],
    openImage: require('../../asset/images/product/pink-open.png'),
    closeImage: require('../../asset/images/product/pink-close.png'),
    uri: '/product/ROSE',
    url: 'https://smartstore.naver.com/levrai_cosmetic/products/7087807656',
  },
];

export const PRODUCT_LINES = {
  BLEU: {
    line: 'RORO MULTI BALM',
    color: 'blue',
    name: 'BLEU',
    weight: 7.4,
    points: [
      {
        kr: '깨끗한 자연에서 온 식물성 원료 사용',
        en: 'CLEAN & NATURAL TREATMENT',
      },
      {
        kr: '저자극+보습 멀티밤',
        en: 'HYPOALLERGENIC + HIGH FUNCTION',
      },
      {
        kr: '프랑스 이브 비건 인증 ',
        en: 'FRANCE EVE VEGAN',
      },
      {
        kr: '트렌디한 디자인과 컬러감',
        en: 'TRENDY DESIGN & COLORS',
      },
    ],
    url: 'https://smartstore.naver.com/levrai_cosmetic/products/7078661867',
  },
  VERT: {
    line: 'RORO MULTI BALM',
    color: 'green',
    name: 'VERT',
    weight: 8,
    points: [
      {
        kr: '깨끗한 자연에서 온 식물성 원료 사용',
        en: 'CLEAN & NATURAL TREATMENT',
      },
      {
        kr: '저자극+진정 멀티밤',
        en: 'HYPOALLERGENIC + HIGH FUNCTION',
      },
      {
        kr: '프랑스 이브 비건 인증 ',
        en: 'FRANCE EVE VEGAN',
      },
      {
        kr: '트렌디한 디자인과 컬러감',
        en: 'TRENDY DESIGN & COLORS',
      },
    ],
    url: 'https://smartstore.naver.com/levrai_cosmetic/products/7087782778',
  },
  ROUGE: {
    line: 'COCO MULTI BALM',
    color: 'red',
    name: 'ROUGE',
    weight: 6.7,
    points: [
      {
        kr: '깨끗한 자연에서 온 식물성 원료 사용',
        en: 'CLEAN & NATURAL TREATMENT',
      },
      {
        kr: '저자극+보습 컬러 멀티밤',
        en: 'HYPOALLERGENIC + HIGH FUNCTION',
      },
      {
        kr: '프랑스 이브 비건 인증 ',
        en: 'FRANCE EVE VEGAN',
      },
      {
        kr: '트렌디한 디자인과 컬러감',
        en: 'TRENDY DESIGN & COLORS',
      },
    ],
    url: 'https://smartstore.naver.com/levrai_cosmetic/products/7087821388',
  },
  ROSE: {
    line: 'COCO MULTI BALM',
    color: 'pink',
    name: 'ROSE',
    weight: 6.7,
    points: [
      {
        kr: '깨끗한 자연에서 온 식물성 원료 사용',
        en: 'CLEAN & NATURAL TREATMENT',
      },
      {
        kr: '저자극+보습 컬러 멀티밤',
        en: 'HYPOALLERGENIC + HIGH FUNCTION',
      },
      {
        kr: '프랑스 이브 비건 인증 ',
        en: 'FRANCE EVE VEGAN',
      },
      {
        kr: '트렌디한 디자인과 컬러감',
        en: 'TRENDY DESIGN & COLORS',
      },
    ],
    url: 'https://smartstore.naver.com/levrai_cosmetic/products/7087807656',
  },
};

export const VEGAN_FEATURES = [
  {
    icon: require('../../asset/images/detail/common/vegan-condition-01.png'),
    title: '원료사용',
  },
  {
    icon: require('../../asset/images/detail/common/vegan-condition-02.png'),
    title: '원료 패키지',
  },
  {
    icon: require('../../asset/images/detail/common/vegan-condition-03.png'),
    title: '실험제조 과정',
  },
];
